import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Button } from "@oc-labs/wt-storybook";

export default function ModalConfirmLogout({ isOpen, closeModal, onConfirm }) {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal}>
                <div className="fixed inset-0 backdrop-brightness-75" />

                <div className="fixed inset-0 flex items-center justify-center">
                    <Dialog.Panel className="w-full max-w-xs bg-white rounded-2xl shadow-lg p-4">
                        <Dialog.Title className="text-lg font-semibold text-center">
                            You are logging out!
                        </Dialog.Title>

                        <Dialog.Description className="mt-2 text-center text-sm">
                            Are you sure you want to log out?
                        </Dialog.Description>

                        <div className="h-[1px] bg-gray-300 my-4" />

                        <div className="mt-4 flex gap-2">
                            <Button
                                type="tertiary"
                                size="small"
                                onClick={closeModal}
                                className="w-1/2"
                            >
                                Cancel
                            </Button>

                            <Button
                                type="primary"
                                size="small"
                                onClick={onConfirm}
                                className="w-1/2"
                            >
                                OK
                            </Button>
                        </div>
                    </Dialog.Panel>
                </div>
            </Dialog>
        </Transition>
    );
}
